<template>
  <d-col cols="12" md="3" lg="3">
    <label for="shipper">
      {{ $t('ui.shipper') }}:
    </label>

    <div :class="{ 'form-control': true, 'is-select': true }">
      <v-select
        :options="shipperOptions"
        v-model="shipper_id"
        :searchable="false"
        :clearable="true"
        :reduce="shipper => shipper.value"
        :placeholder="$t('shippers.chooseShipper')"
        label="text">
        <template slot="no-options">
          {{ $t('shippers.noShippersAvailable') }}&hellip;
        </template>
      </v-select>
    </div>
  </d-col>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'order-select-shipper',
  computed: {
    shipperOptions () {
      return this.shippers.map(shipper => ({
        value: shipper.id,
        text: shipper.name
      }));
    }
  },
  watch: {
    shipper_id (newValue) {
      if (newValue !== 0 && newValue !== null) {
        let shipperData = this.shippers.filter(shipper => shipper.id === newValue);

        if (shipperData[0]) {
          this.selectedShipper = JSON.parse(JSON.stringify(shipperData[0]));
        } else {
          this.selectedShipper = null;
          this.shipper_id = null;
        }

        this.$bus.$emit('order-update-shipment-cost', false);
      } else {
        this.selectedShipper = null;
      }
    },
    loadError (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-error');
      }
    },
    loadedShippers (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-success', 'shippers');
      }
    }
  },
  data () {
    return {
      shipper_id: 0,
      loadedShippers: false,
      shippers: [],
      selectedShipper: null,
      loadError: false
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      endpoint: '/shippers/items',
      loadedKey: 'loadedShippers',
      outputKey: 'shippers',
      errorKey: 'loadError',
      params: {
        with: ['shipperPrices']
      },
      successAction: () => {
        if (this.shipper_id === null) {
          this.shipper_id = this.shippers[0].id;
        }
      }
    });
  }
}
</script>
